module.exports = "query GetCardCategories {\n  cardCategories {\n    ...CardCategoryFragment\n  }\n}\n"